import styled, {css} from 'styled-components';

import { queries } from "../../../../breakpoints"

export const BreadcrumbContainer = styled.div`
  @media(${queries.max_break_md}){
    display:none;
  }
  .MuiBreadcrumbs-li, .MuiBreadcrumbs-separator{
    margin-bottom:0;
  }
`;

export const PreviousBreadcrumb = styled.a`
  color:var(--color-text);
  font-weight:bold;
`;

export const ActiveBreadcrumb = styled.p``;

export const ControlBar = styled.div`
  display:flex;
  margin:3rem 3rem 3rem 5rem;
  justify-content: space-between;
  align-items:center;
  .MuiBreadcrumbs-separator{
    font-weight:bold;
  }
  @media(${queries.max_break_md}){
    flex-flow:column-reverse;
    margin: 1rem 3rem;
    align-items:flex-start;
  }
  @media(${queries.max_break_sm}){
    margin: 1.5rem;
  }
`
export const TypeToggle = styled.div`
  border-radius:50px;
  padding: ${({ showSecondSwitch }) => showSecondSwitch ?"15px 0px":"0px"};
  @media(${queries.max_break_md}){
    margin-bottom: 2rem;
  }
`;

export const ToggleButton = styled.a`
  font-size:var(--fontSize-0);
  font-weight:bold;
  background-color:white;
  color:#6b6b83;
  border:1px solid #6B6B83;
  padding: 10px;
  white-space: nowrap;
  :hover{
    background-color:#6b6b8320;
    color:#6b6b83;
    text-decoration: none;
  }
  ${props => props.active && css`
    color:white;
    background-color:#6b6b83;
    :hover{
      color:white;
      background-color:#6b6b83;
      cursor:default;
    }
  `}
  ${props => props.borderRadius && css`
    border-radius: ${props.borderRadius};
  `}
`;

export const SwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media(${queries.max_break_md}){
    width: 100%
  }
`;
